import { useEffect, useState, useRef } from "react";
import AdminLayout from "../layouts/AdminLayout";
import { hasPermission } from "../utils/permissions";
import { toast } from "react-toastify";

function AdminUsers() {
  const [users, setUsers] = useState([]);
  const prevUserCount = useRef(0);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch("https://kolibusiness.com/backend/admin-users.php");
        const data = await res.json();
        setUsers(data);

        // Compare counts
        if (prevUserCount.current && data.length > prevUserCount.current) {
          const newUser = data[0];
          toast.success(`🎉 New User: ${newUser.first_name} ${newUser.last_name} (${newUser.phone}) signed up!`);
        }

        prevUserCount.current = data.length;
      } catch (err) {
        console.error("Failed to fetch users:", err);
      }
    };
    fetchUsers();

    // Poll every 10 seconds for new signups
    const interval = setInterval(fetchUsers, 10000);
    return () => clearInterval(interval);
  }, []);

  if (!hasPermission("users", "view")) {
    return (
      <AdminLayout>
        <p style={{ color: "red", padding: "20px", fontWeight: "bold" }}>
          ❌ You do not have permission to view users.
        </p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <h2>👥 Registered Users</h2>
      {users.length === 0 ? (
        <p>No users found.</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Phone</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Signup Date</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.id}</td>
                <td>{u.phone}</td>
                <td>{u.first_name}</td>
                <td>{u.last_name}</td>
                <td>{u.created_at}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </AdminLayout>
  );
}

const styles = {
  table: {
    width: "100%",
    background: "#fff",
    padding: "10px",
    borderCollapse: "collapse",
    border: "1px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0,0,0,0.05)",
  },
};

export default AdminUsers;
